import { Crown } from "lucide-react";

/**
 * Small neon-purple "PRO" chip. Renders nothing if user isn't Pro so callers
 * can drop it unconditionally next to any user name / avatar.
 *
 * Props:
 *   isPro   — bool
 *   size    — "xs" | "sm" | "md"  (default sm)
 *   variant — "chip" | "icon"     (chip: PRO text · icon: crown only)
 */
export default function ProBadge({ isPro, size = "sm", variant = "chip", className = "" }) {
  if (!isPro) return null;

  const sizeCls = {
    xs: variant === "chip" ? "text-[8px] px-1 py-[1px]" : "h-3 w-3",
    sm: variant === "chip" ? "text-[9px] px-1.5 py-0.5" : "h-3.5 w-3.5",
    md: variant === "chip" ? "text-[10px] px-2 py-0.5"   : "h-4 w-4",
  }[size];

  if (variant === "icon") {
    return (
      <Crown
        data-testid="pro-badge-icon"
        className={`text-[#B026FF] ${sizeCls} ${className}`}
        strokeWidth={2.4}
        style={{ filter: "drop-shadow(0 0 4px rgba(176,38,255,0.6))" }}
      />
    );
  }

  return (
    <span
      data-testid="pro-badge-chip"
      className={`inline-flex items-center gap-0.5 font-mono font-bold uppercase tracking-widest bg-[#B026FF] text-white shadow-[0_0_6px_rgba(176,38,255,0.55)] ${sizeCls} ${className}`}
    >
      pro
    </span>
  );
}
